import { useMediaQuery, useTheme } from '@mui/material';

export function useMediaIsDesktop() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
export function useMediaIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('sm'));
}
